<style scoped lang="scss">

</style>

<template>
<div v-if="application">
    <fieldset class="agreement-container">
        <legend class="agreement-title">
            Privacy Policy
        </legend>

        <div class="uk-grid">
            <div class="uk-width-1-1">
                <h4>Instructions:</h4>
                <p>
                    Read this Privacy Policy, and keep this document for your records.
                </p>
            </div>
        </div>

        <div class="uk-grid">
            <div class="uk-width-1-1">
                <div class="uk-block uk-block-default">
                    <p>
                        {{ application.program.agency_name }} is committed to assuring the privacy of individuals and/or families who have
                        contacted us for assistance. We realize that the concerns you bring to us are highly
                        personal in nature. We assure you that all information shared both orally and in writing
                        will be managed within legal and ethical considerations. Your "nonpublic personal
                        information," such as your total debt information, income, living expenses and personal
                        information concerning your financial circumstances, will be provided to creditors, program
                        monitors, and others only with your authorization and signature on the Third Party
                        Authorization for Release of Information on step 6. We may also use anonymous aggregated
                        case file information for the purpose of evaluating our services, gathering valuable
                        research information, and designing future programs. Types of information that we gather
                        about you: Information we receive from you orally, on applications or other forms, such as
                        your name, address, social security number, assets, and income; Information about your
                        transactions with us, your creditors, or others, such as your account balance, payment
                        history, parties to transactions and credit card usage. Release of your information to third
                        parties: We may disclose some or all of the information that we collect, as described above,
                        to your creditors or third parties where we have determined that it would be helpful to you,
                        would aid us in counseling you, or is a requirement of the federal assistance funding this
                        program. We may also disclose any nonpublic personal information about you or former
                        customers to anyone as required by law (e.g., if we are compelled by legal process). Within
                        the organization, we restrict access to nonpublic personal information about you to those
                        employees who need to know that information to provide services to you. We maintain physical,
                        electronic, and procedural safeguards that comply with federal and state regulations to
                        guard your nonpublic personal information.
                    </p>
                </div>
            </div>
        </div>

        <div class="uk-grid" v-if="application.household">
            <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                <div v-if="member.age >= 18">
                    <validated-section :field="'signature_'+member.id" :errors="errors">
                        <signature-box @updated="onSignatureUpdated"
                           :user-key="member.id"
                           :is-signed="signatureData[member.id] && signatureData[member.id].privacy_policy_signed_at !== null"
                           :completed="signatureData[member.id] && signatureData[member.id].completed"
                           :name="member.first_name + ' ' + member.last_name"
                           :color="programSettings['primary-program-color']"
                        ></signature-box>
                    </validated-section>

                </div>
            </div>
        </div>
    </fieldset>

</div>
</template>
<script>
    import {mapState, mapGetters} from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    export default {
        name: "Step5",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                errors: {},
                signatureData: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                signatures: state => state.signatures,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-privacy-policy`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, { privacy_policy_signed_at: signatureFiltered.created_at, completed: true });
                        }
                    }
                })
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { privacy_policy_signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].privacy_policy_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;


                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-5`, data)
            }
        }
    }
</script>
